const authPartner = `
    created
    id
    keyCreatedAt
    keyLastUsedAt
    modified
    objType
    publicKey
    valid
`;

export default authPartner;
